export const npmDetailsLink = 'https://docs.npmjs.com/cli/v9/using-npm/scope'

export const tokenPlaceholder = '********'

export const npmDefaultRegistryHost = 'https://registry.npmjs.org/'
